import { z } from 'zod'

export const ImportEmployeesToSMSchema = () => {
  return z.object({
    effectiveAt: z.date(),
    employeeIds: z.array(z.string()),
    numberOfRestDaysInCents: z.number().nullable(),
    employeeSelection: z.discriminatedUnion('type', [
      z.object({
        type: z.literal('manual'),
        ids: z.array(z.string()),
      }),
      z.object({
        type: z.literal('all'),
        filters: z.record(z.unknown()).optional(),
        excludedIds: z.array(z.string()),
        includeInactive: z.boolean().optional(),
      }),
    ]),
  })
}

export type ImportEmployeesToSMSchemaType = z.infer<ReturnType<typeof ImportEmployeesToSMSchema>>
